import { createWebHistory, createRouter } from "vue-router";
const routes = [
    {
        path: "/",
        alias: "/home",
        name: "home",
        component: () => import("./components/LandingPage")
    },
    {
        path: "/list",
        name: "list",
        component: () => import("./components/LifeListDisplay")
    },
    {
        path: "/about",
        name: "about",
        component: () => import("./components/AboutPage")
    },
    {
        path: "/birds/:id",
        name: "view",
        component: () => import("./components/SingleDisplay")
    },
    {
        path: "/status",
        name: "status",
        component: () => import("./components/StatusAggregatePage")
    },
    {
        path: "/login",
        name: "login",
        component: () => import("./components/LoginPage")
    },
    {
        path: "/statuses",
        name: "statuses",
        component: () => import("./components/SillyStatusListPage")
    },
    {
        path: "/bigday",
        name: "aboutbigday",
        component: () => import("./components/BigDayOverviewPage")
    },
    {
        path: "/bigday/:date",
        name: "viewbigday",
        component: () => import("./components/BigDayViewPage"),
    },
    {
        path: "/*",
        alias: "/404",
        name: "404",
        component: () => import("./components/NotFound")
    }
    // Login, Logout, and non-GET requests on birds, :id, photos
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;